import React from "react";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";

function SiteFooter() {
  return (
    <div class="row  overlayfooter">
			<div class="row">

				{/* <!-- About --> */}
				<div class="col-lg-4 footer_col">
					<div class="footer_about">
						<div class="logo_container" >
							<a href="#">
								<div class="logo_content d-flex flex-row align-items-end justify-content-start">
									{/* <div class="logo_img"><img src="./images/spst-home-icon.png" alt="logo" className="footerimage"/></div> */}
									<div><h3 style={{color:'white'}}>Sree Krishna Maruthi Temple</h3></div>
								</div>
							</a>
						</div>
						<div class="clear" style={{paddingTop:'20%'}}>
							<p className="foottest">ജഗദ് ഗുരുവായ ശ്രീകൃഷ്ണഭഗവാനും ജ്ഞാനമൂർത്തിയായ ആഞ്ജനേയസ്വാമിയും തുല്യപ്രാധാന്യത്തിൽ കുടികൊള്ളുന്ന ക്ഷേത്രമാണ് ശ്രീകൃഷ്ണ മാരുതി ക്ഷേത്രം. തൃശ്ശൂർ ജില്ലയിൽ കൊടുങ്ങല്ലൂർ താലൂക്കിലെ എടവിലങ്ങ് കാരയിലാണ് ശ്രീകൃഷ്ണമാരുതിക്ഷേത്രം നില കൊളളുന്നത്. മറ്റു ക്ഷേത്രങ്ങളിൽ ആഞ്ജനേയൻ വൈഷ്ണവ സങ്കല്പത്തിലാണ് പ്രതിഷ്ഠയെങ്കിൽ ഇവിടെ ഹനുമാൻ സ്വാമി ശൈവരൂപത്തിൽ കുടികൊള്ളുന്നു എന്നതും സവിശേഷതയാണ്. വൈഷ്ണവ രൂപത്തിൽ ശ്രീകൃഷ്ണ ഭഗവാനും ശാക്തേയ രൂപത്തിൽ തണ്ണികുളങ്ങര ഭദ്രകാളി ദേവിയും നിറസാന്നിധ്യമായി കുടികൊള്ളുന്ന ശൈവവൈഷ്ണവശാക്തേയസംഗമ ക്ഷേത്രമാണിവിടം.  </p>
						</div>
						{/* <div class="footer_social">
							<ul>
								<li><a href="#"><i class="fa fa-google-plus" aria-hidden="true"></i></a></li>
								<li><a href="#"><i class="fa fa-pinterest" aria-hidden="true"></i></a></li>
								<li><a href="#"><i class="fa fa-facebook" aria-hidden="true"></i></a></li>
								<li><a href="#"><i class="fa fa-twitter" aria-hidden="true"></i></a></li>
							</ul>
						</div> */}
						
					</div>
				</div>

				<div class="col-lg-4 footer_col">
					<div class="footer_links">
						<div class="footer_title">Quick menu</div>
						<ul className="footer_list">
							<li><Link to="/">Home</Link></li>
							<li><Link to="#">Online Booking</Link></li>
							<li><Link to="/History">History</Link></li>
							<li><Link to="/Administration">Administration</Link></li>
							<li><Link to="/Contact">Contact</Link></li>
						</ul>
					</div>
				</div>

				{/* <div class="col-lg-2 footer_col">
					<div class="footer_links">
						<div class="footer_title">Useful Links</div>
						<ul class="footer_list">
							<li><Link to="https://booking.sreepadmanabhaswamytemple.org/">Online Booking</Link></li>
							<li><Link to="https://booking.sreepadmanabhaswamytemple.org/OtherOfferings.aspx?Pid=1&Vid=75">Suvarna Darsan</Link></li>
							<li><Link to="https://booking.sreepadmanabhaswamytemple.org/OtherOfferings.aspx?Pid=1&Vid=72">Kshethra Bhadratha Fund</Link></li>
							<li><Link to="https://booking.sreepadmanabhaswamytemple.org/Murajepam.aspx">Gosala Donation</Link></li>
						</ul>
					</div>
				</div> */}

				<div class="col-lg-4 footer_col">
					<div class="footer_contact">
						<div class="footer_title">Contact Us</div>
						<div class="footer_contact_info">
							<div class="footer_contact_item">
								<div class="footer_contact_title orange">Address:</div>
								<div class="footer_contact_line">
									<p style={{color:'white',lineHeight:'15pt'}}>Sreekrishna Maruthi temple
                    Maruthipuram,  kara <br />
                    edavilangu village
                    kodungallur<br />
                    Thrissur,
                    Kerala <br />
                    pin 680671 </p> 
									{/* Ulsavamadam Building , North Nada<br />
									Sree Padmanabha Swamy Temple Fort,<br />
									Thiruvananthapuram – 695023.</p> */}
								</div>
							</div>
							<div class="footer_contact_item">
								<div class="footer_contact_title orange">Phone:</div>
								<div class="footer_contact_line white">8129981222 </div>
							</div>
							<div class="footer_contact_item">
								<div class="footer_contact_title orange">Email:</div>
								<div class="footer_contact_line white">sreekrishnamaruthitemple@gmail.com</div>
							</div>
						</div>
					</div>
				</div>
				<div className="copyrightbottom">
					<div class="row">
						<div class="col-md-8">
							<div class="copyrighttext">
								<p class="foottest" style={{lineHeight:'20px'}}>Copyright © 2025 Sree Krishna Maruthi Temple, All Rights Reserved.  <br/> 
								<Link to="./TermsAndConditions">Terms & Conditions </Link> Enabled by Kshethrasuvidham Temple Management Solutions.</p>
								
							</div>
						</div>
						<div class="col-md-4">
							<div className="footerlogo">
								<img src="./images/kshethrasuvidhamLogo.jpg" style={{width:'50%'}} />
							</div>
						</div>
					</div>
					
					
				</div>
			</div>
		</div>
  );
}

export default SiteFooter;

